import {
  Card,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import {
  emailOutboundSearchAddressBook,
  emailTemplateSearch,
  emailTemplateSearchSuccess,
  sendEmailOutbound,
  sendEmailOutboundScheduled,
  sendEmailOutboundScheduledSuccess,
  sendEmailOutboundSuccess,
} from "../../store/CRMitEmailInbox/action";
import { useDispatch, useSelector } from "react-redux";
import "./common.styles.scss";

import SearchAttachments from "./SearchAttachments";
import { uploadJobFilesApiCall } from "../../helpers/fakebackend_helper";
import EmailTemplateSelection from "./EmailTemplateSelection";
import EmailPlaceholderFill from "./EmailPlaceholderFill";
import {
  extractPlaceholders,
  replacePlaceholdersInEditorContent,
  replacePlaceholdersInText,
} from "./emailPlaceholders";
import RichTextEditor from "../RichTextEditor";
import { proformaInvoiceData } from "../../store/ProformaInvoice/action";
import {
  getSingleInvoiceData,
  searchSingleCustomerInvoiceList,
} from "../../store/invoiceCrmIT/action";
import {
  dateFormatReverse,
  handleDateFormat,
  handleValidDateTime,
  RestructuredDate,
  timeFormatDateAndTime,
  timeFormatDateAndTimeNoSeconds,
} from "./HandleDateTime";
import Flatpickr from "react-flatpickr";
import { timerTimeEntryStartDateTime } from "../../store/timeEntries/action";
import LoadingSpinner from "./Spinner";
import { getCustomersListData } from "../../store/customers/action";

// --- DND-KIT IMPORTS ---
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
  pointerWithin,
} from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import { CustomChipInput } from "./CustomChipInput";

// Change #100058 - the statement attachment types, only when present. A
// backend that predates them rejects the key even when its list is empty,
// which broke every invoice email ("Attachments can only be added from ...
// API received: CustomerStatement") until the backend upload landed.
const statementAttachmentKeys = (attachments) => {
  const keys = {};
  ["CustomerStatement", "CustomerStatementAll"].forEach((type) => {
    const ids = (attachments || [])
      .filter((attachment) => attachment?.type === type)
      .map((attachment) => attachment?.id);
    if (ids.length) keys[type] = ids;
  });
  return keys;
};

// Changes #100121 / #100123 - files kept on a customer, and files uploaded in
// this window for this email only. Like the statements, a key is only sent
// when it has something in it: a backend without these types refuses an
// unknown non-empty key, so an empty one must never be sent.
const fileAttachmentKeys = (attachments) => {
  const keys = {};
  ["CustomerAttachment", "FileAttachment"].forEach((type) => {
    const ids = (attachments || [])
      .filter((attachment) => attachment?.type === type)
      .map((attachment) => attachment?.id);
    if (ids.length) keys[type] = ids;
  });
  return keys;
};

const readAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const SendEmail = ({
  modal,
  setModal,
  toggle,
  externalEMailTo,
  page,
  moduleData,
  itemId,
  customerId,
  Job_Id,
  opportunity_Id,
  // Change #100058 - when the attachment is not the module itself (a
  // statement is attached as "CustomerStatement"/"CustomerStatementAll"
  // while moduleData stays "CustomerStatement").
  attachmentType,
  attachmentLabel,
  // Change #100688 - the Job_Ids on the record's item lines, preselected in
  // the attachment search's Job List.
  jobIds,
}) => {
  const dispatch = useDispatch();
  const localDataUserEmail = JSON.parse(localStorage.getItem("authUser"))
    ?.get_user_data?.User_Email;
  const hasInitializedAttachments = useRef(false);
  // Task 24331 — true once this modal has dispatched its own template search,
  // so a leftover result from the previously composed record can't prefill.
  const ownTemplateSearchRef = useRef(false);
  const [emailTo, setEmailTo] = useState(externalEMailTo ?? "");
  const [emailCc, setEmailCc] = useState("");
  const [emailBcc, setEmailBcc] = useState("");
  const [showCc, setShowCc] = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");

  const [emailFrom, setEmailFrom] = useState(localDataUserEmail);
  const [attachments, setAttachments] = useState([]);
  // Change #100121 - upload a file straight into this email.
  const uploadInputRef = useRef(null);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const handleUploadFiles = async (event) => {
    const files = Array.from(event?.target?.files || []);
    if (event?.target) event.target.value = "";
    if (!files.length) return;
    setUploadingFiles(true);
    const added = [];
    // One request per file, so each comes back with its own FileAttachment_Id
    // whichever backend answers.
    for (const file of files) {
      try {
        const response = await uploadJobFilesApiCall([
          {
            FileName: file.name,
            Name: file.name,
            Description: "",
            Notes: "Uploaded while composing an email",
            FileType: file.type,
            FileSizeBytes: file.size,
            FileBase64: await readAsDataUrl(file),
            AttachmentCategoryType_Id: null,
          },
        ]);
        if (response?.status === 200 && response?.FileAttachment_Id) {
          added.push({
            id: response.FileAttachment_Id,
            type: "FileAttachment",
            label: file.name,
          });
        } else {
          toast.error(response?.message || `Could not upload ${file.name}`);
        }
      } catch (e) {
        toast.error(`Could not upload ${file.name}`);
      }
    }
    if (added.length) {
      setAttachments((current) => [...(current || []), ...added]);
      toast.success(
        added.length === 1
          ? `Attached ${added[0].label}`
          : `Attached ${added.length} files`
      );
    }
    setUploadingFiles(false);
  };
  console.log("attachments", attachments);
  const [contactListTo, setContactListTo] = useState([]);
  const [contactListCc, setContactListCc] = useState([]);
  const [contactListBcc, setContactListBcc] = useState([]);
  const [scheduleEmail, setScheduleEmail] = useState(false);
  const [scheduledSendDateTime, setScheduledSendDateTime] = useState(null);
  const handleEmailContentChange = (event) => {
    setEmailBody(event);
  };
  const [localStaffName, setLocalStaffName] = useState(
    JSON.parse(localStorage.getItem("authUser"))?.get_staff_data?.FullName
  );

  // Build a chip for the currently logged-in user. No
  // CustomerToContactPersonRelationship_Id on `item`, so it is sent as a raw
  // email address (same path as a free-typed address).
  const buildMeChip = () => ({
    firstLine: {
      icon: "fa-solid fa-person-shelter",
      label: localStaffName || "Me",
    },
    secondLine: {
      icon: "fa-solid fa-person",
      label: localStaffName || "Me",
    },
    thirdLine: {
      icon: "fa-solid fa-envelope",
      label: localDataUserEmail,
    },
    id: `me-${localDataUserEmail}`,
    value: localDataUserEmail,
    item: {},
  });

  // Add the logged-in user to Cc/Bcc, opening the section and avoiding dupes.
  const addMeToList = (setShow, setChipList) => {
    if (!localDataUserEmail) return;
    setShow(true);
    setChipList((prev) =>
      prev.some((c) => c?.thirdLine?.label === localDataUserEmail)
        ? prev
        : [...prev, buildMeChip()]
    );
  };

  // --- DND-KIT LOGIC START ---
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5, // Requires a 5px drag to start (prevents firing on regular clicks)
      },
    })
  );

  const findContainer = (id) => {
    // Check which list the currently dragged chip belongs to. Check both `id` and `lid` just in case.
    if (id === "to" || contactListTo.some((c) => (c.id || c.lid) === id))
      return "to";
    if (id === "cc" || contactListCc.some((c) => (c.id || c.lid) === id))
      return "cc";
    if (id === "bcc" || contactListBcc.some((c) => (c.id || c.lid) === id))
      return "bcc";
    return null;
  };

  const handleDragOver = (event) => {
    const { active, over } = event;
    if (!over) return;

    const activeContainer = findContainer(active.id);
    const overContainer = findContainer(over.id);

    if (
      !activeContainer ||
      !overContainer ||
      activeContainer === overContainer
    ) {
      return;
    }

    const setListMap = {
      to: setContactListTo,
      cc: setContactListCc,
      bcc: setContactListBcc,
    };

    const listMap = {
      to: contactListTo,
      cc: contactListCc,
      bcc: contactListBcc,
    };

    const activeItem = listMap[activeContainer].find(
      (item) => (item.id || item.lid) === active.id
    );

    setListMap[activeContainer]((prev) =>
      prev.filter((item) => (item.id || item.lid) !== active.id)
    );

    setListMap[overContainer]((prev) => {
      const overIndex = prev.findIndex(
        (item) => (item.id || item.lid) === over.id
      );
      let newIndex = overIndex >= 0 ? overIndex : prev.length;
      const newItems = [...prev];
      newItems.splice(newIndex, 0, activeItem);
      return newItems;
    });
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    const activeContainer = findContainer(active.id);
    const overContainer = findContainer(over.id);

    if (
      !activeContainer ||
      !overContainer ||
      activeContainer !== overContainer
    ) {
      return;
    }

    const listMap = {
      to: contactListTo,
      cc: contactListCc,
      bcc: contactListBcc,
    };
    const setListMap = {
      to: setContactListTo,
      cc: setContactListCc,
      bcc: setContactListBcc,
    };

    const currentList = listMap[activeContainer];
    const activeIndex = currentList.findIndex(
      (c) => (c.id || c.lid) === active.id
    );
    const overIndex = currentList.findIndex((c) => (c.id || c.lid) === over.id);

    if (activeIndex !== overIndex) {
      setListMap[activeContainer]((items) =>
        arrayMove(items, activeIndex, overIndex)
      );
    }
  };
  // --- DND-KIT LOGIC END ---

  const handleSendEmail = () => {
    if (isEmpty(emailBody)) {
      toast.error("Please enter email body");
      return;
    }
    if (isEmpty(emailSubject)) {
      toast.error("Please enter email subject");
      return;
    }
    if (isEmpty(contactListTo)) {
      toast.error("Please enter email to");
      return;
    }
    // Task 24575 — still refuse to send an unresolved {{token}}, but point at
    // the Fill placeholders button rather than just saying "not allowed".
    if (subjectHasPlaceholder || bodyHasPlaceholder) {
      setPlaceholderNames(extractPlaceholders([emailSubject, emailBody]));
      setPlaceholderModal(true);
      toast.error(
        "This message still has placeholders in it. Fill them in before sending."
      );
      return;
    }

    // we need to filter !CustomerToContactPersonRelationship_Id so as long as it dose not have an id we should take
    //thirdLine.label so result sohuld be ["email@email.com", "email2@email.com"]
    const contactPersonEmailAddress_EmailAddress = contactListTo
      ?.filter(
        (contact) => !contact?.item?.CustomerToContactPersonRelationship_Id
      )
      .map((contact) => contact?.thirdLine?.label);

    //contactPersonEmailAddress_Id should contain only [22, 44] ids
    const contactPersonEmailAddress_Id = contactListTo
      ?.filter(
        (contact) => contact?.item?.CustomerToContactPersonRelationship_Id
      )
      .map((contact) => contact?.item?.CustomerToContactPersonRelationship_Id);
    // now we need to do same thing for cc and bcc
    const contactPersonEmailAddress_EmailAddressCc = contactListCc
      ?.filter(
        (contact) => !contact?.item?.CustomerToContactPersonRelationship_Id
      )
      .map((contact) => contact?.thirdLine?.label);
    const contactPersonEmailAddress_IdCc = contactListCc
      ?.filter(
        (contact) => contact?.item?.CustomerToContactPersonRelationship_Id
      )
      .map((contact) => contact?.item?.CustomerToContactPersonRelationship_Id);

    const contactPersonEmailAddress_EmailAddressBcc = contactListBcc
      ?.filter(
        (contact) => !contact?.item?.CustomerToContactPersonRelationship_Id
      )
      .map((contact) => contact?.thirdLine?.label);
    const contactPersonEmailAddress_IdBcc = contactListBcc
      ?.filter(
        (contact) => contact?.item?.CustomerToContactPersonRelationship_Id
      )
      .map((contact) => contact?.item?.CustomerToContactPersonRelationship_Id);
    const sendEmailData = [
      {
        module_data: moduleData ?? "Default",
        EmailFromAddress: emailFrom,
        EmailFromName: localStaffName ?? "Customer Support",
        EmailTo: {
          EmailAddress: contactPersonEmailAddress_EmailAddress,
          ContactPersonEmailAddress_Id: contactPersonEmailAddress_Id,
        },
        EmailCc: {
          EmailAddress: contactPersonEmailAddress_EmailAddressCc,
          ContactPersonEmailAddress_Id: contactPersonEmailAddress_IdCc,
        },
        EmailBcc: {
          EmailAddress: contactPersonEmailAddress_EmailAddressBcc,
          ContactPersonEmailAddress_Id: contactPersonEmailAddress_IdBcc,
        },
        EmailSubject: emailSubject,
        EmailContentHtml: emailBody,
        EmailAttachment: {
          Invoice: attachments
            ?.filter((attachment) => attachment?.type === "Invoice")
            ?.map((attachment) => attachment?.id), //filtered by type "Invoice"
          JobAttachment: attachments
            ?.filter((attachment) => attachment?.type === "JobAttachment")
            ?.map((attachment) => attachment?.id), //filtered by type "JobAttachment"
          // Change #100058 - Statement of Account PDF, built at send time.
          // Only sent when there is one (see statementAttachmentKeys).
          ...statementAttachmentKeys(attachments),
          TaskChecklist: attachments
            ?.filter((attachment) => attachment?.type === "Checklist")
            ?.map((attachment) => attachment?.id), //filtered by type "TaskChecklist"

          ProformaInvoice: attachments
            ?.filter((attachment) => attachment?.type === "ProformaInvoice")
            ?.map((attachment) => attachment?.id), //filtered by type "ProformaInvoice"
          Quote: attachments
            ?.filter((attachment) => attachment?.type === "Quote")
            ?.map((attachment) => attachment?.id), //filtered by type "Quote"
          PurchaseOrder: attachments //filtered by type "PurchaseOrder"
            ?.filter((attachment) => attachment?.type === "PurchaseOrder")
            ?.map((attachment) => attachment?.id),
          // Changes #100121 / #100123 - only present when used.
          ...fileAttachmentKeys(attachments),
        },
      },
    ];
    if (scheduleEmail) {
      sendEmailData[0].ScheduledSendDateTime = scheduledSendDateTime;
      dispatch(sendEmailOutboundScheduled(sendEmailData));
    } else {
      dispatch(sendEmailOutbound(sendEmailData));
    }
  };
  const { emailSendAPIResponse, emailTemplateSendScheduledAPI } = useSelector(
    (state) => ({
      emailSendAPIResponse: state.EmailInbound.emailSend,
      emailTemplateSendScheduledAPI:
        state.EmailInbound.emailTemplateSendScheduled,
    })
  );
  const { emailOutboundAddressBookAPI } = useSelector((state) => ({
    emailOutboundAddressBookAPI:
      state.EmailInbound.emailOutboundAddressBook
        ?.contactpersonemailaddress_list?.contactperson,
  }));
  const { emailTemplateSearchAPI, emailTemplateSearchLoading } = useSelector(
    (state) => ({
      emailTemplateSearchAPI:
        state.EmailInbound.emailTemplateSearch?.emailtemplate_list,
      emailTemplateSearchLoading: state.EmailInbound.emailTemplateSearchLoading,
    })
  );
  const [contactList, setContactList] = useState([]);

  // Task 24331 — the template search result lives in redux and used to survive
  // the compose modal closing, so opening it on a second record prefilled the
  // subject/body with the PREVIOUS record's rendered template. Drop that result
  // on open and on close, so the body can only ever be filled from this
  // record's own template response.
  useEffect(() => {
    dispatch(emailTemplateSearchSuccess([]));
    return () => {
      dispatch(emailTemplateSearchSuccess([]));
    };
  }, []);

  useEffect(() => {
    dispatch(getCustomersListData());

    if (!isEmpty(page)) return;
    dispatch(
      emailOutboundSearchAddressBook({
        // in this example hard code to invoice module and invoice id
        module_data: moduleData ?? "Default",
      })
    );
  }, []);

  useEffect(() => {
    if (itemId && !hasInitializedAttachments.current) return;
    // Task 24331 — from here on, a template response belongs to THIS record.
    ownTemplateSearchRef.current = true;
    dispatch(
      emailTemplateSearch({
        module_data: moduleData ?? "Default",
        EmailAttachment: {
          Invoice: attachments
            ?.filter((attachment) => attachment?.type === "Invoice")
            ?.map((attachment) => attachment?.id), //filtered by type "Invoice"
          JobAttachment: attachments
            ?.filter((attachment) => attachment?.type === "JobAttachment")
            ?.map((attachment) => attachment?.id), //filtered by type "JobAttachment"
          // Change #100058 - Statement of Account PDF, built at send time.
          // Only sent when there is one (see statementAttachmentKeys).
          ...statementAttachmentKeys(attachments),
          TaskChecklist: attachments
            ?.filter((attachment) => attachment?.type === "Checklist")
            ?.map((attachment) => attachment?.id), //filtered by type "TaskChecklist"

          ProformaInvoice: attachments
            ?.filter((attachment) => attachment?.type === "ProformaInvoice")
            ?.map((attachment) => attachment?.id), //filtered by type "ProformaInvoice"
          Quote: attachments
            ?.filter((attachment) => attachment?.type === "Quote")
            ?.map((attachment) => attachment?.id), //filtered by type "Quote"
        },
      })
    );
  }, [attachments]);

  // emailOutboundSearchAddressBook
  useEffect(() => {
    if (isEmpty(page)) return;
    dispatch(
      emailOutboundSearchAddressBook({
        // in this example hard code to invoice module and invoice id
        module_data: moduleData,
        ...(page === "invoiceDetails"
          ? {
              invoice_data: {
                Id: [itemId],
              },
            }
          : {}),
        ...(page === "proformaInvoiceDetails"
          ? {
              proformainvoice_data: {
                Id: [itemId],
              },
            }
          : {}),
        ...(page === "singleCustomer"
          ? { customer_data: { Id: [customerId] } }
          : {}),
        ...(page === "SingleJob" ? { job_data: { Id: [Job_Id] } } : {}),
        ...(page === "singleOpportunity"
          ? { opportunity_data: { Id: [opportunity_Id] } }
          : {}),
        ...(page === "quote" ? { quote_data: { Id: [itemId] } } : {}),
        ...(page === "purchaseOrder"
          ? { purchaseorder_data: { Id: [itemId] } }
          : {}),
      })
    );
    if (itemId) {
      setAttachments([
        {
          id: itemId,
          type: attachmentType || moduleData,
          label: attachmentLabel || "#" + itemId,
          lid: 1,
        },
      ]);
    }
    // 🔥 We have finished our initial setup. Flip the flag to true.
    hasInitializedAttachments.current = true;
  }, [page, itemId, customerId]);

  useEffect(() => {
    if (isEmpty(emailOutboundAddressBookAPI)) return;
    let tempContactListTo = [];
    let tempContactListCc = [];
    let tempContactListBcc = [];
    emailOutboundAddressBookAPI?.forEach((contact, index) => {
      // 1. Generate the unique ID to fix the DND-kit faded chip issue
      const uniqueId =
        contact?.CustomerToContactPersonRelationship_Id ||
        `fallback-id-${index}-${Date.now()}`;

      // 2. Build the chip object once (DRY principle)
      const chipObject = {
        firstLine: {
          icon: "fa-solid fa-person-shelter",
          label: contact?.Customer_FullName,
        },
        secondLine: {
          icon: "fa-solid fa-person",
          label: contact?.ContactPerson_FullName,
        },
        thirdLine: {
          icon: "fa-solid fa-envelope",
          label: contact?.ContactPersonEmailAddress_EmailAddress,
        },
        id: uniqueId, // <--- Fix applied here
        value: contact?.CustomerToContactPersonRelationship_Id,
        item: contact,
      };

      // 3. Push the finalized object to whichever lists require it
      if (contact?.ZFlagPreSelectedBcc === "1") {
        tempContactListBcc.push(chipObject);
      }

      if (contact?.ZFlagPreSelectedCc === "1") {
        tempContactListCc.push(chipObject);
      }

      if (contact?.ZFlagPreSelectedTo === "1") {
        tempContactListTo.push(chipObject);
      }
    });
    setContactListTo(tempContactListTo);
    setContactListCc(tempContactListCc);
    setContactListBcc(tempContactListBcc);

    if (!isEmpty(tempContactListCc)) {
      setShowCc(true);
    }
    if (!isEmpty(tempContactListBcc)) {
      setShowBcc(true);
    }
    // first check if ZFlagPreferred === "1" and group them at the top and then sort by order ZFlagOrder in DESC order
    // frst get all ZFlagPreferred to the top
    let preferredEmailList = emailOutboundAddressBookAPI.filter(
      (email) => email.ZFlagPreferred === "1"
    );
    let nonPreferredEmailList = emailOutboundAddressBookAPI.filter(
      (email) => email.ZFlagPreferred !== "1"
    );
    // now sort prefered emails by order
    let sortedEmailList = preferredEmailList.sort(
      (a, b) => b.ZFlagOrder - a.ZFlagOrder
    );
    // add them together
    sortedEmailList = [...sortedEmailList, ...nonPreferredEmailList];
    if (isEmpty(preferredEmailList)) {
      // if no preferred email then sort by order
      sortedEmailList = emailOutboundAddressBookAPI.sort(
        (a, b) => b.ZFlagOrder - a.ZFlagOrder
      );
    }
    setContactList(sortedEmailList);
  }, [emailOutboundAddressBookAPI]);

  useEffect(() => {
    if (isEmpty(emailSendAPIResponse)) return;
    if (emailSendAPIResponse.status === 200) {
      toast.success(emailSendAPIResponse.message);

      if (moduleData === "Invoice") {
        dispatch(getSingleInvoiceData({ id: itemId }));
      }
      if (moduleData === "ProformaInvoice") {
        dispatch(proformaInvoiceData({ id: itemId }));
      }
      if (customerId) {
        dispatch(
          searchSingleCustomerInvoiceList([
            {
              invoice_data: {
                Customer_Id: customerId,
              },
            },
          ])
        );
      }
      setModal(false);
    } else {
      toast.error(emailSendAPIResponse.message);
    }
    dispatch(sendEmailOutboundSuccess([]));
  }, [emailSendAPIResponse]);

  //emailTemplateSendScheduledAPI
  useEffect(() => {
    if (isEmpty(emailTemplateSendScheduledAPI)) return;
    if (emailTemplateSendScheduledAPI.status === 200) {
      toast.success(emailTemplateSendScheduledAPI.message);
      if (moduleData === "Invoice") {
        dispatch(getSingleInvoiceData({ id: itemId }));
      }
      if (moduleData === "ProformaInvoice") {
        dispatch(proformaInvoiceData({ id: itemId }));
      }
      setModal(false);
    } else {
      toast.error(emailTemplateSendScheduledAPI.message);
    }
    dispatch(sendEmailOutboundScheduledSuccess([]));
  }, [emailTemplateSendScheduledAPI]);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  const [allowedFilters, setAllowedFilters] = useState([
    "Customer_FullName",
    "ContactPerson_FirstName",
    "ContactPerson_LastName",
    "ContactPersonEmailAddress_EmailAddress",
  ]);

  useEffect(() => {
    if (isEmpty(contactList)) return;
    let allowedSearchFilters = allowedFilters;
    let filteredDataList = contactList;
    filteredDataList = filteredDataList?.filter((item) => {
      return allowedSearchFilters?.some((key) => {
        return (
          item[key] &&
          item[key]
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchQuery?.toLowerCase())
        );
      });
    });
    setSearchResult(filteredDataList);
  }, [searchQuery, contactList]);

  const [selectedTemplate, setSelectedTemplate] = useState("");
  // Change #100658 - the template can pin the sender to its own From address.
  const senderReadOnly = Number(selectedTemplate?.FlagSenderReadOnly) === 1;
  const [templateSelectModal, setTemplateSelectModal] = useState(false);
  const toggleTemplateSelectModal = () => {
    setTemplateSelectModal(!templateSelectModal);
  };

  // Task 24575 — what gets pushed *into* the Lexical editor. Previously the
  // editor was fed straight from `selectedTemplate.BodyHtml`, which meant the
  // body could only ever be replaced by picking another template. Holding it in
  // state lets us push a placeholder-substituted body back in as well.
  const [editorContent, setEditorContent] = useState("");
  const [placeholderModal, setPlaceholderModal] = useState(false);
  const [placeholderNames, setPlaceholderNames] = useState([]);
  const [placeholderValues, setPlaceholderValues] = useState({});

  // Applying a template is the same job whether the user picked it or it was
  // pre-selected for the record, so both paths go through here.
  const applyTemplate = (template) => {
    if (isEmpty(template)) return;
    setSelectedTemplate(template);
    setEmailSubject(template?.Subject);
    setEditorContent(template?.BodyHtml);
    handleEmailContentChange(template?.BodyHtml);
    //change fromEmail
    setEmailFrom(template?.FromEmail);
    //Change fromName
    setLocalStaffName(template?.FromName);

    // Task 24575 — anything still written as {{Token}} is a merge field the
    // backend could not resolve for this record. Ask for it now, up front,
    // instead of blocking the send later with nothing but a red warning.
    const names = extractPlaceholders([template?.Subject, template?.BodyHtml]);
    setPlaceholderNames(names);
    setPlaceholderValues({});
    setPlaceholderModal(names.length > 0);
  };

  const handleTemplateSelect = (template) => {
    setTemplateSelectModal(false);
    applyTemplate(template);
  };

  // Re-open the fill-in modal from the button next to the subject. Names are
  // recomputed from what's on screen so anything typed by hand is picked up too.
  const openPlaceholderModal = () => {
    setPlaceholderNames(extractPlaceholders([emailSubject, emailBody]));
    setPlaceholderModal(true);
  };

  const handlePlaceholderApply = (values) => {
    setPlaceholderValues(values);
    setPlaceholderModal(false);

    const nextSubject = replacePlaceholdersInText(emailSubject, values);
    // Substitute into the *current* editor payload, not the original template,
    // so edits made before filling the placeholders in aren't thrown away.
    const nextBody = replacePlaceholdersInEditorContent(
      emailBody || editorContent,
      values
    );

    setEmailSubject(nextSubject);
    setEditorContent(nextBody);
    handleEmailContentChange(nextBody);
    setPlaceholderNames(extractPlaceholders([nextSubject, nextBody]));
  };

  const [isClearEditor, setIsClearEditor] = useState(false);
  const [sendDisabled, setSendDisabled] = useState(false);
  const [bodyHasPlaceholder, setBodyHasPlaceholder] = useState(false);
  const [subjectHasPlaceholder, setSubjectHasPlaceholder] = useState(false);
  useEffect(() => {
    if (isEmpty(emailSubject)) return;
    //   we need to check if emailSubject has {{ and }} if it dose have set subjectHasPlaceholder to true
    if (emailSubject.includes("{{") && emailSubject.includes("}}")) {
      setSubjectHasPlaceholder(true);
    } else {
      setSubjectHasPlaceholder(false);
    }
  }, [emailSubject]);

  useEffect(() => {
    if (isEmpty(emailBody)) return;
    //   we need to check if emailBody has {{ and }} if it dose have set bodyHasPlaceholder to true
    if (emailBody?.includes("{{") && emailBody?.includes("}}")) {
      setBodyHasPlaceholder(true);
    } else {
      setBodyHasPlaceholder(false);
    }
  }, [emailBody]);

  useEffect(() => {
    if (isEmpty(emailTemplateSearchAPI)) return;
    // Task 24331 — ignore a result that predates this modal's own search,
    // otherwise the previous record's body/subject is prefilled here.
    if (!ownTemplateSearchRef.current) return;
    const findPreselectedTemplateData = emailTemplateSearchAPI?.find(
      (template) => template.ZFlagPreSelected === "1"
    );
    console.log("emailTemplateSearchAPI", emailTemplateSearchAPI);
    console.log(
      "************findPreselectedTemplateData",
      findPreselectedTemplateData
    );
    if (!isEmpty(findPreselectedTemplateData)) {
      applyTemplate(findPreselectedTemplateData);
    }
  }, [emailTemplateSearchAPI]);
  const [activeSearchTab, setActiveSearchTab] = useState(null);
  const [sortedCustomerId, setSortedCustomerId] = useState([]);
  const [selectedJobsId, setSelectedJobsId] = useState([]);
  // Change #100688 - distinct, non-empty job ids from the record (or the job
  // itself when composing from a job).
  const fallbackJobIds = useMemo(() => {
    const ids = !isEmpty(jobIds) ? jobIds : Job_Id ? [Job_Id] : [];
    return [...new Set(ids.filter((id) => id && id !== "0"))];
  }, [jobIds, Job_Id]);
  return (
    <div>
      {templateSelectModal && (
        <EmailTemplateSelection
          modal={templateSelectModal}
          toggle={toggleTemplateSelectModal}
          templates={emailTemplateSearchAPI}
          selectTemplate={handleTemplateSelect}
        />
      )}
      {/* Task 24575 — opens itself when a template loads with unresolved
          {{placeholders}}, and again from the "Fill placeholders" button. */}
      <EmailPlaceholderFill
        open={placeholderModal}
        onClose={() => setPlaceholderModal(false)}
        placeholders={placeholderNames}
        initialValues={placeholderValues}
        onApply={handlePlaceholderApply}
      />
      <Modal
        id="composemodal"
        size={"xl"}
        isOpen={modal}
        toggle={toggle}
        centered
      >
        <ModalHeader className="p-3 bg-light" toggle={toggle}>
          New Message
        </ModalHeader>

        <ModalBody>
          {/* --- DND-KIT WRAPPER --- */}
          <DndContext
            sensors={sensors}
            collisionDetection={pointerWithin}
            onDragOver={handleDragOver}
            onDragEnd={handleDragEnd}
          >
            <div>
              <div>
                <div>
                  <div className={"w-100"}>
                    <CustomChipInput
                      id="to" // <-- Added id prop for droppable zone
                      placeholder={"To"}
                      chipList={contactListTo}
                      setChipList={setContactListTo}
                      // style={{ maxWidth: "770px" }}
                      options={
                        contactList?.map((contact) => ({
                          firstLine: {
                            icon: "fa-solid fa-person-shelter",
                            label: contact?.Customer_FullName,
                          },
                          secondLine: {
                            icon: "fa-solid fa-person",
                            label: contact?.ContactPerson_FullName,
                          },
                          thirdLine: {
                            icon: "fa-solid fa-envelope",
                            label:
                              contact?.ContactPersonEmailAddress_EmailAddress,
                          },
                          id: contact?.CustomerToContactPersonRelationship_Id,
                          value:
                            contact?.CustomerToContactPersonRelationship_Id,
                          item: contact,
                        })) ?? []
                      }
                      onClickCallBack={(contact) => {
                        setContactListTo([...contactListTo, contact]);
                      }}
                    />
                    <div className="position-absolute top-0 end-0">
                      <div className="d-flex">
                        {localDataUserEmail && (
                          <>
                            <button
                              className="btn btn-link text-reset fw-semibold px-2"
                              type="button"
                              title={`Cc me (${localDataUserEmail})`}
                              onClick={() =>
                                addMeToList(setShowCc, setContactListCc)
                              }
                            >
                              Cc me
                            </button>
                            <button
                              className="btn btn-link text-reset fw-semibold px-2"
                              type="button"
                              title={`Bcc me (${localDataUserEmail})`}
                              onClick={() =>
                                addMeToList(setShowBcc, setContactListBcc)
                              }
                            >
                              Bcc me
                            </button>
                          </>
                        )}
                        <button
                          className="btn btn-link text-reset fw-semibold px-2"
                          type="button"
                          onClick={() => setShowCc(!showCc)}
                        >
                          Cc
                        </button>
                        <button
                          className="btn btn-link text-reset fw-semibold px-2"
                          type="button"
                          onClick={() => setShowBcc(!showBcc)}
                        >
                          Bcc
                        </button>
                      </div>
                    </div>
                  </div>

                  {showCc && (
                    <div className="">
                      <div className="position-absolute end-0">
                        <div className="d-flex">
                          <button
                            className="btn btn-link text-reset fw-semibold px-2"
                            type="button"
                            onClick={() => setShowCc(!showCc)}
                          >
                            Hide Cc
                          </button>
                        </div>
                      </div>
                      <CustomChipInput
                        id="cc" // <-- Added id prop for droppable zone
                        chipList={contactListCc}
                        setChipList={setContactListCc}
                        placeholder={"Cc"}
                        // style={{ maxWidth: "770px" }}
                        options={
                          contactList?.map((contact) => ({
                            firstLine: {
                              icon: "fa-solid fa-person-shelter",
                              label: contact?.Customer_FullName,
                            },
                            secondLine: {
                              icon: "fa-solid fa-person",
                              label: contact?.ContactPerson_FullName,
                            },
                            thirdLine: {
                              icon: "fa-solid fa-envelope",
                              label:
                                contact?.ContactPersonEmailAddress_EmailAddress,
                            },
                            id: contact?.CustomerToContactPersonRelationship_Id,
                            value:
                              contact?.CustomerToContactPersonRelationship_Id,
                            item: contact,
                          })) ?? []
                        }
                        onClickCallBack={(contact) => {
                          setContactListCc([...contactListCc, contact]);
                        }}
                      />
                    </div>
                  )}
                  {showBcc && (
                    <div className="">
                      <div className="position-absolute end-0">
                        <div className="d-flex">
                          <button
                            className="btn btn-link text-reset fw-semibold px-2"
                            type="button"
                            onClick={() => setShowBcc(!showBcc)}
                          >
                            Hide Bcc
                          </button>
                        </div>
                      </div>
                      <CustomChipInput
                        id="bcc" // <-- Added id prop for droppable zone
                        placeholder={"Bcc"}
                        chipList={contactListBcc}
                        setChipList={setContactListBcc}
                        // style={{ maxWidth: "770px" }}
                        options={
                          contactList?.map((contact) => ({
                            firstLine: {
                              icon: "fa-solid fa-person-shelter",
                              label: contact?.Customer_FullName,
                            },
                            secondLine: {
                              icon: "fa-solid fa-person",
                              label: contact?.ContactPerson_FullName,
                            },
                            thirdLine: {
                              icon: "fa-solid fa-envelope",
                              label:
                                contact?.ContactPersonEmailAddress_EmailAddress,
                            },
                            id: contact?.CustomerToContactPersonRelationship_Id,
                            value:
                              contact?.CustomerToContactPersonRelationship_Id,
                            item: contact,
                          })) ?? []
                        }
                        onClickCallBack={(contact) => {
                          setContactListBcc([...contactListBcc, contact]);
                        }}
                      />
                    </div>
                  )}

                  <div className="mb-3 mt-3">
                    {/* Task 24575 — unresolved {{tokens}} still block the send,
                        but the user now gets a way to fix them in one go
                        instead of editing them out of the body by hand. */}
                    {(subjectHasPlaceholder || bodyHasPlaceholder) && (
                      <div className="alert alert-warning py-1 px-2 mb-2 d-flex align-items-center gap-2 flex-wrap">
                        <i className="ri-error-warning-line" />
                        <span>
                          This message still has placeholders (
                          {` {{...}} `}) that couldn't be filled in
                          automatically.
                        </span>
                        <button
                          type="button"
                          className="btn btn-sm btn-warning"
                          onClick={openPlaceholderModal}
                        >
                          Fill placeholders
                        </button>
                      </div>
                    )}
                    <Input
                      type="text"
                      style={{ borderColor: subjectHasPlaceholder && "red" }}
                      className="form-control"
                      placeholder="Subject"
                      value={emailSubject}
                      onChange={(e) => setEmailSubject(e.target.value)}
                    />
                  </div>
                  <div
                    onClick={() => {
                      setSelectedTemplate("");
                      toggleTemplateSelectModal();
                    }}
                  >
                    <span
                      className={
                        "badge cursor-pointer " +
                        (selectedTemplate
                          ? "badge-soft-warning"
                          : "badge-soft-success")
                      }
                    >
                      {selectedTemplate ? "Change Template" : "Select Template"}
                    </span>
                  </div>
                  {/* Warn when templates exist for this record but none was
                      auto-selected, so a blank body doesn't look broken. */}
                  {!emailTemplateSearchLoading &&
                    !selectedTemplate &&
                    !isEmpty(emailTemplateSearchAPI) &&
                    !emailTemplateSearchAPI?.some(
                      (template) => template?.ZFlagPreSelected === "1"
                    ) && (
                      <div
                        className="alert alert-warning py-1 px-2 mt-2 mb-0 d-flex align-items-center gap-2"
                        role="alert"
                      >
                        <i className="ri-error-warning-line" />
                        <span>
                          No default email template was found for this record, so
                          the message body is blank. Click{" "}
                          <strong>Select Template</strong> above to choose one, or
                          just type your message.
                        </span>
                      </div>
                    )}
                  <div className="ck-editor-reverse">
                    <RichTextEditor
                      style={{ borderColor: bodyHasPlaceholder && "red" }}
                      handleContentChange={(e) => handleEmailContentChange(e)}
                      isClearEditor={isClearEditor}
                      setIsClearEditor={setIsClearEditor}
                      autoFocus={false}
                      initialValue={emailBody}
                      placeholder={emailBody ? emailBody : `Enter email text`}
                      receivedContent={editorContent}
                    />
                  </div>
                  <div>
                    <Row className={"mt-2"}>
                      <Col lg={6}>
                        <Label>From Name</Label>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="From: Name"
                          value={localStaffName}
                          readOnly={senderReadOnly}
                          onChange={(e) => setLocalStaffName(e.target.value)}
                        ></Input>
                      </Col>
                      <Col lg={6}>
                        <Label>From Email</Label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="From: Email"
                          value={emailFrom}
                          readOnly={senderReadOnly}
                          onChange={(e) => setEmailFrom(e.target.value)}
                        />
                      </Col>
                      {senderReadOnly && (
                        <Col lg={12}>
                          <small className="text-muted">
                            <i className="ri-lock-line me-1" />
                            The sender is set by the &quot;
                            {selectedTemplate?.Title}&quot; template and cannot
                            be changed.
                          </small>
                        </Col>
                      )}
                    </Row>
                  </div>
                  <div>
                    <Row className={"mt-2"}>
                      {/* checkbox schedule email*/}
                      <Col lg={6} className={"mt-2"}>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                            checked={scheduleEmail}
                            onChange={(e) => setScheduleEmail(e.target.checked)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckDefault"
                          >
                            Schedule Email
                          </label>
                        </div>
                      </Col>
                      {/* date time picker*/}
                      {scheduleEmail && (
                        <Col lg={6}>
                          <Flatpickr
                            className={
                              "form-control start-finish-time-tracking-input"
                            }
                            options={{
                              enableTime: true,
                              dateFormat: "Y-m-d H:i",
                              // defaultDate: timeFormatDateAndTimeNoSeconds(
                              //   new Date()[0]
                              // ),
                            }}
                            value={
                              scheduledSendDateTime
                                ? new Date(scheduledSendDateTime)
                                : ""
                            }
                            onChange={(date) => {
                              setScheduledSendDateTime(
                                handleValidDateTime(date)
                              );
                            }}
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </DndContext>
          {/* --- END DND-KIT WRAPPER --- */}

          <div>
            {!isEmpty(attachments) && (
              <div>
                <hr />
                <Label>Attachments</Label>
                <div>
                  {attachments?.map((attachment, index) => (
                    <div
                      key={index}
                      className={"badge badge-soft-dark me-1 mt-1"}
                    >
                      <div>
                        <div>
                          {attachment?.type === "FileAttachment"
                            ? "Uploaded file"
                            : attachment?.type === "CustomerAttachment"
                            ? "Customer file"
                            : attachment?.type}
                        </div>
                        <div>{attachment?.label}</div>
                      </div>
                      <div>
                        {/* remove*/}
                        <button
                          type="button"
                          className="btn btn-sm text-danger"
                          onClick={() => {
                            let tempAttachments = attachments;
                            tempAttachments.splice(index, 1);
                            setAttachments([...tempAttachments]);
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <hr />
            {/* Change #100121 - a file from this computer, for this email. */}
            <div className="d-flex align-items-center gap-2 mb-2">
              <input
                ref={uploadInputRef}
                type="file"
                multiple
                className="d-none"
                onChange={handleUploadFiles}
              />
              <button
                type="button"
                className="btn btn-sm btn-soft-primary"
                disabled={uploadingFiles}
                onClick={() => uploadInputRef.current?.click()}
              >
                <i className="ri-upload-2-line me-1"></i>
                {uploadingFiles ? "Uploading..." : "Upload a file"}
              </button>
              <span className="text-muted fs-12">
                Attach something from your computer to this email only.
              </span>
            </div>
            <SearchAttachments
              attachments={attachments}
              fallbackCustomerId={customerId}
              fallbackJobIds={fallbackJobIds}
              setAttachments={setAttachments}
              emailCustomerList={contactListTo}
              activeSearchTab={activeSearchTab}
              setActiveSearchTab={setActiveSearchTab}
              sortedCustomerId={sortedCustomerId}
              setSortedCustomerId={setSortedCustomerId}
              selectedJobsId={selectedJobsId}
              setSelectedJobsId={setSelectedJobsId}
            />
          </div>
        </ModalBody>
        {/*)}*/}
        {!emailTemplateSearchLoading && (
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-ghost-danger"
              onClick={() => {
                setModal(false);
              }}
            >
              Discard
            </button>

            <UncontrolledDropdown className="btn-group" disabled={sendDisabled}>
              <button
                type="button"
                className="btn btn-success"
                onClick={
                  // setModal(false);
                  handleSendEmail
                }
              >
                {scheduleEmail ? "Schedule" : "Send"}
              </button>
              {/*<DropdownToggle*/}
              {/* tag="button"*/}
              {/* type="button"*/}
              {/* className="btn btn-success"*/}
              {/* split*/}
              {/*>*/}
              {/* <span className="visually-hidden">Toggle Dropdown</span>*/}
              {/*</DropdownToggle>*/}
              {/*<DropdownMenu className="dropdown-menu-end">*/}
              {/* <li>*/}
              {/* <DropdownItem href="#">*/}
              {/* <i className="ri-timer-line text-muted me-1 align-bottom"></i>{" "}*/}
              {/* Schedule Send*/}
              {/* </DropdownItem>*/}
              {/* </li>*/}
              {/*</DropdownMenu>*/}
            </UncontrolledDropdown>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default SendEmail;
